import { types, getParent, flow } from 'mobx-state-tree';
import { LocationRow } from './models';
import { resolvePaginationStore } from '../PaginationStore';

const LocationsStore = types
  .model('LocationsStore', {
    locations: types.array(LocationRow),
    pagination: types.optional(
      resolvePaginationStore({
        onChangePerPage: (self) => getParent(self).loadLocations(),
        onChangePage: (self, page) => getParent(self).loadLocations({ page }),
      }),
      {
        perPage: 50
      },
    ),
  })
  .volatile(self => ({
    loading: false,
  }))
  .views(self => ({
    get root() {
      return getParent(self);
    },
  }))
  .actions(self => ({
    loadLocations: flow(function* ({ page = 1 } = {}) {
      try {
        self.loading = true;
        const response = yield self.root.api.location.index({ page: page, per_page: self.pagination.perPage });
        self.locations = response.data.data;
        self.pagination.setFromMeta(response.data.meta);
      } catch (error) {
        self.root.ui.toast.error(error);
      }
      self.loading = false;
    }),
    destroy: flow(function* (id) {
      let response;
      if (window.confirm('Are you sure to delete it?')) {
        try {
          self.loading = true;
          response = yield self.root.api.location.destroy(id);
          self.loadLocations();
        } catch (error) {
          self.root.ui.toast.error(error);
        }
        self.loading = false;
      }
    }),
  }))


export default LocationsStore;
